import { render, staticRenderFns } from "./nb-iot-layout.vue?vue&type=template&id=03b9aaed&scoped=true&"
import script from "./nb-iot-layout.vue?vue&type=script&lang=js&"
export * from "./nb-iot-layout.vue?vue&type=script&lang=js&"
import style0 from "./nb-iot-layout.vue?vue&type=style&index=0&id=03b9aaed&prod&lang=scss&scoped=true&"
import style1 from "./nb-iot-layout.vue?vue&type=style&index=1&id=03b9aaed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b9aaed",
  null
  
)

export default component.exports